// chart-theme.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChartThemeService {
  private theme = ['##00FF7F', '##9D69FF', '##00FFFF', '##FFD700'];
  // Add other themes

  getCurrentPalette(): string[] {
    return this.theme;
  }

  getCustomPalette(colors: string[]): string[] {
    return colors.length > 0 ? colors : this.theme;
  }
}
